<template>
  <div :key="componentKey" :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo" style="text-align: center;">
      <div v-if="this.$store.state.betgameData" style="color: white; font-size: large; padding-left: 10px; padding-right: 10px;">
        {{ this.$store.state.betgameData.name }}
      </div>
      <!--
      <el-select style="width: 90%;" class="select-danger"
                 @change="betgameSelected"
                 placeholder="Single Select"
                 v-model="selects.simple">
        <el-option v-for="option in authoredBetgames"
                   class="select-danger"
                   :value="option.value"
                   :label="option.label"
                   :key="option.id">
        </el-option>
      </el-select>
      -->
      <!--
      <a class="simple-text logo-normal" style="text-align: center" target="_blank" href="http://www.sportplatz-media.com/">
          {{ title }}
      </a>
      -->
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        selects: {
          simple: this.$store.state.betgame,
          countries: [],
          multiple: 'ARS'
        },
        componentKey: 0
      }
    },
    created () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_BETGAME_DATA') {
          if (!this.selects.simple) {
            this.selects.simple = this.$store.state.betgameData.id
            this.betgameSelected()
          }
        }
      })
    },
    mounted () {
      this.initScrollBarAsync()
      /*
      if (this.$store.state.authoredBetgames.length > 0) {
        this.selects.countries = []
        for (let j in this.$store.state.authoredBetgames) {
          let i = this.$store.state.authoredBetgames[j]
          this.$log.debug('################################## ' + JSON.stringify(i))
          this.selects.countries.push({value: '' + i.fk_betgame, label: '' + i.bg_betgame.name})
        }
      } else {

      }
      */
    },
    props: {
      title: {
        type: String,
        default: 'Tippspiel'
      },
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/vue-logo.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      authoredBetgames () {
        // this.$log.debug('authoredBetgames ' + JSON.stringify(this.$store.state.ownedBetgames))
        // this.$log.debug('authoredBetgames ' + JSON.stringify(this.$store.state.authoredBetgames))
        var result = []
        /*
        if (this.$store.state.betgameData) {
          result.push({value: '' + this.$store.state.betgameData.id, label: '' + this.$store.state.betgameData.name + ' (' + this.$store.state.betgameData.id + ')'})
          this.selects.simple = this.$store.state.betgameData.id
          this.betgameSelected()
        } else if (this.$store.state.betgame) {
          result.push({value: '' + this.$store.state.betgame, label: '(' + this.$store.state.betgame + ')'})
          this.selects.simple = this.$store.state.betgame
          this.betgameSelected()
        } else {
          const id = parseInt(window.sessionStorage.getItem('bgbackend_betgameid'))
          result.push({value: '' + id, label: '(' + id + ')'})
          this.selects.simple = id
          this.betgameSelected()
        }
        */
        for (let j in this.$store.state.ownedBetgames) {
          let i = this.$store.state.ownedBetgames[j]
          // this.$log.debug('owner ' + JSON.stringify(i))
          result.push({value: '' + i.id, label: '' + i.name + ' (' + i.id + ')'})
          if (!this.selects.simple) {
            this.selects.simple = i.id
            this.betgameSelected()
          }
        }
        for (let j in this.$store.state.authoredBetgames) {
          let i = this.$store.state.authoredBetgames[j]
          // this.$log.debug('author ' + JSON.stringify(i))
          const temp = result.filter(r => r.value === '' + i.fk_betgame)
          if (temp.length === 0) {
            result.push({value: '' + i.fk_betgame, label: '' + i.bg_betgame.name + ' (' + i.fk_betgame + ')'})
            if (!this.selects.simple) {
              this.selects.simple = i.fk_betgame
              this.betgameSelected()
            }
          }
        }
        result = result.sort((a, b) => a.value - b.value)
        return result
      },
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      betgameSelected () {
        this.$log.debug('betgameSelected ' + this.selects.simple)
        this.$store.dispatch('fetchUserStatistics', this.selects.simple)
        this.$store.dispatch('setBetgame', this.selects.simple).then(() => {
          this.$store.dispatch('fetchBetgame', this.selects.simple).then(() => {
            this.$store.dispatch('fetchBetgameCompetition', this.selects.simple).then(() => {
              this.$store.dispatch('fetchLastMatchday', this.$store.state.competition).then(() => {
                this.$store.dispatch('fetchMatchdayRankings', {fk_betgame: this.selects.simple, fk_competition: this.$store.state.competition, matchday: this.$store.state.matchday}).then(() => {
                  // this.$router.push({ name: 'Tippspiel' })
                  this.componentKey += 1
                  this.$router.push('/betgamedata').catch(_ => {
                    // this.$log.error(err)
                  })
                })
              })
            })
          })
        })
      },
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        if (this.$refs.sidebarScrollArea) {
          PerfectScroll.initialize(this.$refs.sidebarScrollArea)
        }
      }
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  .select-danger > div {
    font-size: smaller;
  }
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue